import { Grid, Typography, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import InfoToolTip from '../../common/InfoToolTip';
import { SmartMonitorOptions } from './SmartMonitorOptions';

export const LRU_OPTIONS_TITLE = 'LRU Options';
export const LRU_UNITS_TITLE = 'Units';
export const LRU_UNITS_SELECT_TITLE = 'Unit Numbers';

LRUOptions.propTypes = {
  currentLRU: PropTypes.object,
  updateCurrentLRU: PropTypes.func
};

export function LRUOptions({ currentLRU, updateCurrentLRU }) {
  // get currentLRU, sortedKeys, and firstUncheckedIndex to reduce duplicated efforts
  const { units } = currentLRU;
  const sortedKeys = useMemo(
    () => Object.keys(units).sort((a, b) => Number(a) - Number(b)),
    [units]
  );
  const firstUncheckedIndex = useMemo(
    () => sortedKeys.findIndex((key) => !units[key]),
    [sortedKeys, units]
  );

  const setLRUUnits = (event) => {
    // get target, copy currentLRU.units, and index of current target
    const { name, checked } = event.target;
    const updatedUnits = { ...units };
    const clickedIndex = sortedKeys.indexOf(name);

    // if all checked update unit value, otherwise set it and any units after it to false
    if (checked) {
      updatedUnits[name] = true;
    } else {
      sortedKeys.slice(clickedIndex).forEach((key) => {
        updatedUnits[key] = false;
      });
    }

    // updateCurrentLRU(s);
    updateCurrentLRU({ ...currentLRU, units: updatedUnits });
  };

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6">{LRU_OPTIONS_TITLE}</Typography>
      </Grid>
      <Grid container item ml={2} xs={12}>
        {Object.keys(currentLRU.units).length > 0 ? (
          <Grid item xs={12}>
            <Typography variant="subtitle1" mb={1}>
              {LRU_UNITS_TITLE}
              <InfoToolTip title="Specifying more unit numbers will deploy more LRUs of the same type." />
            </Typography>
            <FormGroup row>
              {sortedKeys.map((key, index) => {
                const isEnabled = firstUncheckedIndex === -1 || index <= firstUncheckedIndex;

                return (
                  <FormControlLabel
                    key={key}
                    checked={units[key]}
                    control={<Checkbox name={key.toString()} disabled={!isEnabled} />}
                    onChange={setLRUUnits}
                    label={key}
                  />
                );
              })}
            </FormGroup>
          </Grid>
        ) : null}
        {currentLRU.value === 'smartmonitor' ? (
          <SmartMonitorOptions lru={currentLRU} updateLRU={updateCurrentLRU} />
        ) : null}
      </Grid>
    </>
  );
}
